'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthsAgo.js
// module id = 720
// module chunks = 0